module.exports = __webpack_public_path__ + "images/psp/24-HourIcons/24-SizeChartTwo/iconOne.svg";